import { useState } from "react";
import { toast } from "sonner";
import { Bell, Save } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Separator } from "../ui/separator";

export const NotificationsSection = () => {
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [reminderDays, setReminderDays] = useState("1");

  return (
    <Card className="card-surface" data-testid="notifications-card">
      <CardHeader style={{ borderBottom: '1px solid var(--t-border)', padding: '16px 20px' }}>
        <div className="flex items-center gap-3">
          <Bell className="w-5 h-5" style={{ color: 'var(--t-text-muted)' }} />
          <div>
            <CardTitle className="text-lg font-semibold" style={{ color: 'var(--t-text)', fontFamily: 'var(--t-heading-font)' }}>
              Notifications
            </CardTitle>
            <CardDescription style={{ color: 'var(--t-text-muted)' }}>Configure email notification preferences</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-5 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-base" style={{ color: 'var(--t-text)' }}>Email Notifications</Label>
            <p className="text-sm" style={{ color: 'var(--t-text-muted)' }}>Receive email reminders for upcoming tasks</p>
          </div>
          <Switch checked={emailNotifications} onCheckedChange={setEmailNotifications} data-testid="toggle-email-notifications" />
        </div>
        <Separator style={{ background: 'var(--t-border)' }} />
        <div className="space-y-2">
          <Label htmlFor="reminder-days" style={{ color: 'var(--t-text)' }}>Default Reminder Days</Label>
          <p className="text-sm mb-2" style={{ color: 'var(--t-text-muted)' }}>
            How many days before a deadline should reminders be sent?
          </p>
          <Input
            id="reminder-days"
            type="number"
            value={reminderDays}
            onChange={(e) => setReminderDays(e.target.value)}
            className="w-24"
            min="1"
            max="14"
            data-testid="input-reminder-days"
          />
        </div>
        <Button onClick={() => toast.success("Notification settings saved")} className="btn-primary" data-testid="save-notifications">
          <Save className="w-4 h-4 mr-2" />
          Save Changes
        </Button>
      </CardContent>
    </Card>
  );
};
